import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loadingFlag:0,
  userList: {},
  locationDropdownList: {},
  userTypes: {},
  errorMessage: null,
  successMessage: null,
  filteredList: {},
  loader: true
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setInitalState: (state, action) => {
      state.successMessage = null;
      state.errorMessage = null;
    },
    getUserListSuccess: (state, action) => {
      state.userList = action.payload;
      state.errorMessage = null;
    },
    getUserListError: (state, action) => {
      state.userList = {};
      state.errorMessage = action.payload;
    },
    getLocationDropdownSuccess: (state, action) => {
      state.locationDropdownList = action.payload;
      state.errorMessage = null;
      state.successMessage = null;
    },
    getLocationDropdownError: (state, action) => {
      state.locationDropdownList = {};
      state.errorMessage = action.payload;
      state.successMessage = null;
    },
    getUserTypesSuccess: (state, action) => {
      state.userTypes = action.payload;
      state.errorMessage = null;
      state.successMessage = null;
    },
    getUserTypesError: (state, action) => {
      state.userTypes = {};
      state.errorMessage = action.payload;
      state.successMessage = null;
    },
    deleteEmployerUserSuccess: (state, action) => {
      state.successMessage = action.payload;
      state.errorMessage = null;
    },
    deleteEmployerUserError: (state, action) => {
      state.successMessage = null;
      state.errorMessage = action.payload;
    },
    setUserMappedLocationData: (state, action) => {
      state.userMappedLocation = action.payload;
    },
    setUserLoder: (state, action) => {
      state.loader = action.payload
    },
    setLoadingFlagIncrement:state => {
      state.loadingFlag = state.loadingFlag + 1
  },
  setLoadingFlagDecrement: state => {
      if (state.loadingFlag !== 0) {
          state.loadingFlag = state.loadingFlag - 1
      }
  }
  },
});
export const {
  setInitalState,
  getUserListSuccess,
  getUserListError,
  getLocationDropdownSuccess,
  getLocationDropdownError,
  getUserTypesSuccess,
  getUserTypesError,
  deleteEmployerUserSuccess,
  deleteEmployerUserError,
  setUserMappedLocationData,
  setUserLoder,
  setLoadingFlagIncrement,
  setLoadingFlagDecrement
} = userSlice.actions;

export default userSlice.reducer;
